var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scroll-root", class: [_vm.classDir, _vm.classHideBar] },
    [
      _c(
        "div",
        { staticClass: "padding", style: _vm.paddingStyle },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }